import React, {useRef} from 'react';
import {Flex} from '@tempo/core';
import {NavLink} from '@tempo/nextjs';
import D4CLogo from '@components/D4CLogo';

import {useActiveArtist, useUser} from '@deezer/next/contexts/main/hooks';
import {getUserDefaultRoute} from '@deezer/next/shared/utils/user';

const Navigation = () => {
	const user = useUser();
	const navRef = useRef<HTMLDivElement>(null);
	const activeArtist = useActiveArtist();

	return (
		<Flex
			ref={navRef}
			as="nav"
			sx={{
				alignItems: 'center',
				justifyContent: {base: 'flex-start', sm: 'space-between'},
				background: 'background.neutral.primary.default',
				borderBottom: '1px solid',
				borderBottomColor: 'divider.neutral.primary.default',
				height: {base: 'fit-content', sm: 'd4c.navbar.height.sm'},
				width: '100%',
				position: 'fixed',
				left: 0,
				top: 0,
				zIndex: 'sticky',
				flexFlow: {base: 'row wrap', sm: 'row'},
			}}
		>
			<NavLink
				href={getUserDefaultRoute(user, activeArtist)}
				data-testid="home-logo"
				py="spacing.l"
				px={{base: 'spacing.l', sm: 'spacing.2xl'}}
			>
				<D4CLogo width="180px" height="48px" />
			</NavLink>
		</Flex>
	);
};

export default Navigation;
